import React from 'react';
import service from "../../../service/service";
import DownloadReport from "../DownloadReport";

export default function UnusedEc2DownloadReport() {
    const apiCallFunction = service.monitoring().downloadEc2
    return <DownloadReport downloadFunction={apiCallFunction} title={'Download unused EC2 report'}/>
}